import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Form from './Form'
import { formTypeList } from '../../constants/form'
import { GET_ONE_PRODUCT_STYLE } from '../../store/types'
import { getOneProductStyle } from '../../store/actions/productStyleAction'

const Edit = ({ id, setOpen }) => {
    const dispatch = useDispatch()
    const { productStyle } = useSelector((state) => state.productCategory)
    useEffect(() => {
        dispatch(getOneProductStyle(id))
        return () => {
            dispatch({
                type: GET_ONE_PRODUCT_STYLE,
                payload: null,
            })
        }
    }, [dispatch, id])
    return productStyle ? (
        <Form
            formType={formTypeList.EDIT}
            setOpen={setOpen}
            propsValue={productStyle}
        />
    ) : null
}

export default Edit
